import { render } from "./PatientDetails.vue?vue&type=template&id=0bd4a72d&scoped=true"
import script from "./PatientDetails.vue?vue&type=script&lang=js"
export * from "./PatientDetails.vue?vue&type=script&lang=js"

import "./PatientDetails.vue?vue&type=style&index=0&id=0bd4a72d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd4a72d"],['__file',"src/components/PatientDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bd4a72d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bd4a72d', __exports__)) {
    api.reload('0bd4a72d', __exports__)
  }
  
  module.hot.accept("./PatientDetails.vue?vue&type=template&id=0bd4a72d&scoped=true", () => {
    api.rerender('0bd4a72d', render)
  })

}


export default __exports__